import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFacebook(props: IconProps & { invert?: boolean }) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h9.887v-8.96H9v-3.952h2.887v-1.54c0-2.656 1.987-5.048 4.43-5.048H19.5v3.953h-3.183c-.348 0-.755.424-.755 1.06v1.575H19.5v3.953h-3.938V24H22a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z"
        fill={props.invert ? '#fff' : '#4963A4'}
      />
    </BaseIcon>
  );
}
